export default () => {
  const searchForms = document.querySelectorAll('.c-search-form');

  [].forEach.call(searchForms, searchForm => {
    const submitButton = searchForm.querySelector('.c-search-form__submit');
    const searchInput = searchForm.querySelector('.c-search-form__input');

    if (submitButton !== null && searchInput !== null) {
      const submitAction = event => {
        if (searchInput.value.length < 1) {
          event.preventDefault();
        }
      };

      searchForm.addEventListener('submit', submitAction);

      if (searchForm.classList.contains('c-navigation__search')) {
        searchInput.addEventListener('focus', () => {
          searchInput.parentNode.classList.add('active');
        });
        searchInput.addEventListener('blur', () => {
          searchInput.parentNode.classList.remove('active');
        });
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js